import { useSelector } from "react-redux";

const useRoleCheck = () => {
  const roles = useSelector((state) => state.auth.data.roles);
  const entities = useSelector((state) => state.auth.data.entities);

  const hasRole = (rolePrefix) => {
    return roles.some((role) => role.startsWith(rolePrefix));
  };

  const hasPermission = (
    requiredRoles,
    conditionalRoles = [],
    entity = null,
    isReadComponent = true
  ) => {
    // Check for Admin or App.ReadAll roles
    if (
      roles.includes("Admin.Manage") ||
      (isReadComponent && roles.includes("App.ReadAll"))
    ) {
      return true;
    }

    // Check if any of the required roles are present
    const hasRequiredRole = requiredRoles.some((role) => hasRole(role));
    if (hasRequiredRole) {
      return true;
    }

    // Check conditional roles (require specific clinic)
    return conditionalRoles.some((role) => {
      return hasRole(role) && entities.includes(entity);
    });
  };

  return { hasPermission };
};

export default useRoleCheck;
